import React, { FunctionComponent, useState } from 'react';
import { useEffect } from 'react';

import styles from './index.module.scss';

type Props = { currentIndex; images };

const loadedImages = {};

const ImageFader: FunctionComponent<Props> = ({ currentIndex, images }): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const [loadedIndex, setLoadedIndex] = useState(currentIndex);

  useEffect(() => {
    if (!loadedImages[currentIndex]) {
      setLoading(true);
      const img = new Image();
      img.onload = () => {
        setLoading(false);
        loadedImages[currentIndex] = true;
        setLoadedIndex(currentIndex);
      };
      img.src = images[currentIndex].image.asset.url;
    } else {
      setLoadedIndex(currentIndex);
    }
  }, [currentIndex]);

  const imageStyle = {
    backgroundImage: `url(${images[loadedIndex].image.asset.url})`,
  };

  return (
    <span className={styles.root} style={imageStyle}>
      {loading && <div id="loading"></div>}
    </span>
  );
};


export default ImageFader;
